import React from 'react';
import extractThreadIdFromMark from '../utils/extractThreadIdFromMark';
import getCommentDecoratorId from '../utils/getCommentDecoratorId';

var NOOP = function NOOP(x) {
  return x;
};

export default function CommentInline(_ref) {
  var store = _ref.pluginStore,
      _ref$toggleComments = _ref.toggleComments,
      toggleComments = _ref$toggleComments === void 0 ? NOOP : _ref$toggleComments,
      mark = _ref.mark,
      attributes = _ref.attributes,
      _ref$displayThread = _ref.displayThread,
      displayThread = _ref$displayThread === void 0 ? true : _ref$displayThread,
      children = _ref.children;
  var threadId = React.useMemo(function () {
    return extractThreadIdFromMark(mark);
  }, [mark]);
  var id = React.useMemo(function () {
    return getCommentDecoratorId(threadId);
  }, [threadId]);
  var onToggleComments = React.useCallback(function () {
    return toggleComments({
      threadId: threadId
    });
  }, [threadId, toggleComments]);
  var onMouseMove = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    store.updateItem('hoveredThreadId', threadId);
  }, [store, threadId]);
  var onMouseLeave = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    store.updateItem('hoveredThreadId', null);
  }, [store]);
  return displayThread ? React.createElement("span", Object.assign({}, attributes, {
    id: id,
    className: "slite-editor-comment pointer transition radius-small",
    "data-thread-id": threadId,
    onClick: onToggleComments,
    onMouseMove: onMouseMove,
    onMouseLeave: onMouseLeave
  }), children) : React.createElement("span", Object.assign({}, attributes, {
    id: id
  }), children);
}